import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: "root"
})
export class ProspectViewService {
  private url = `${environment.API}prospect`;

  constructor(private http: HttpClient) {}

  getProspects(prospect: String): Observable<any> {
    return this.http.post(this.url, {
      tiporeq: "C",
      id: prospect
    });
  }
}
